"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactForm = _interopRequireDefault(require("@micado-digital/react-form"));
var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));
var _formContext = _interopRequireDefault(require("@micado-digital/react-form/context/formContext"));
var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));
var _Select = _interopRequireDefault(require("@micado-digital/react-form/Select"));
var _Checkbox = _interopRequireDefault(require("@micado-digital/react-form/Checkbox"));
var _Button = _interopRequireDefault(require("@micado-digital/react-form/Button"));
var _Message = _interopRequireDefault(require("@micado-digital/react-form/Message"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _checkVatRules = _interopRequireDefault(require("../../../config/checkVatRules"));
var _shopTypes = _interopRequireDefault(require("../../../config/shopTypes"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _getStatesByCountry = _interopRequireDefault(require("../../../utils/getStatesByCountry"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _FormGuest = _interopRequireDefault(require("./FormGuest.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FormContent = _ref => {
  let {
    buttonLabel,
    buttonRef,
    lang
  } = _ref;
  const css = (0, _FormGuest.default)();
  const [formConfig] = (0, _react.useContext)(_formContext.default);
  const {
    cart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    address
  } = cart || {};
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    countries,
    type: shopType
  } = shopData;
  const [addressData, setAddressData] = (0, _react.useState)({});
  const [billingCountryCode, setBillingCountryCode] = (0, _react.useState)();
  const [billingStateCode, setBillingStateCode] = (0, _react.useState)();
  const [countryCode, setCountryCode] = (0, _react.useState)();
  const [stateCode, setStateCode] = (0, _react.useState)();
  const [type, setType] = (0, _react.useState)("private");
  let {
    company,
    billingCompany,
    billingEmail,
    billingFirstName,
    billingLastName,
    billingPhone,
    billingSalutation,
    billingStreet,
    billingTown,
    billingZipCode,
    email,
    firstName,
    lastName,
    phone,
    salutation,
    street,
    town,
    vat,
    zipCode
  } = addressData || {};
  const {
    errorFields = {},
    formLocked,
    response: {
      data: {
        msg: formMsg
      } = {}
    } = {}
  } = formConfig;
  const [formMessageObj, setFormMessageObj] = (0, _react.useState)({});
  const [billingAddress, setBillingAddress] = (0, _react.useState)(false);
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const cartGUID = localStorage.getItem("mco-shop-cart-guid");
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(address)) return;
    let _address = {};
    const billingAddress = address === null || address === void 0 ? void 0 : address.billing;
    const shippingAddress = address === null || address === void 0 ? void 0 : address.shipping;
    if (billingAddress) {
      _address.billingCompany = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.company;
      _address.billingEmail = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email;
      _address.billingFirstName = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.firstName;
      _address.billingLastName = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.lastName;
      _address.billingPhone = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phone;
      _address.billingSalutation = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.salutation;
      _address.billingStreet = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.street;
      _address.billingTown = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.town;
      _address.billingZipCode = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.zipCode;
      setBillingAddress(true);
      setBillingCountryCode(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode);
      setBillingStateCode(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.stateCode);
    }
    _address.company = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.company;
    _address.email = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.email;
    _address.firstName = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.firstName;
    _address.lastName = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.lastName;
    _address.phone = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phone;
    _address.salutation = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.salutation;
    _address.street = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.street;
    _address.town = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.town;
    _address.type = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.type;
    _address.vat = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.vat;
    _address.zipCode = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.zipCode;
    setAddressData(_address);
    setCountryCode(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode);
    setStateCode(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.stateCode);
    setType(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.type);
  }, [address]);
  (0, _react.useEffect)(() => {
    setAddressData(prevAddressData => ({
      ...prevAddressData,
      billingCountryCode,
      billingStateCode
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingCountryCode, billingStateCode]);
  (0, _react.useEffect)(() => {
    setAddressData(prevAddressData => ({
      ...prevAddressData,
      countryCode,
      stateCode,
      type
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, stateCode, type]);
  (0, _react.useEffect)(() => {
    if (!formMsg) return;
    switch (formMsg) {
      case "ok":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.success.ADDRESS_SAVED",
              l: l
            }),
            type: "success"
          });
          break;
        }
      case "parameter_missing":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ADDRESS_NOT_SAVED",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "parameter_invalid":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ADDRESS_NOT_SAVED",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "authorization_error":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.CUSTOMER_NOT_AUTHORIZED",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "vat_invalid":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.VAT_INVALID",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "not_found":
      default:
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ADDRESS_NOT_SAVED",
              l: l
            }),
            type: "error"
          });
          break;
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formConfig]);
  const billingStates = (0, _react.useMemo)(() => {
    return (0, _getStatesByCountry.default)(countries, billingCountryCode);
  }, [countries, billingCountryCode]);
  const states = (0, _react.useMemo)(() => {
    return (0, _getStatesByCountry.default)(countries, countryCode);
  }, [countries, countryCode]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cartGUID && /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "cartGUID",
    value: cartGUID
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["salutation"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.salutation"),
    name: "salutation",
    required: true,
    subItems: [{
      "attr-value": l("reactShop.addresses.Mr"),
      text: l("reactShop.addresses.Mr")
    }, {
      "attr-value": l("reactShop.addresses.Mrs"),
      text: l("reactShop.addresses.Mrs")
    }, {
      "attr-value": l("reactShop.addresses.Divers"),
      text: l("reactShop.addresses.Divers")
    }],
    value: salutation,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.addresses.company"),
    name: "company",
    value: company,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["firstName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.firstname"),
    name: "firstName",
    required: true,
    value: firstName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["lastName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.lastname"),
    name: "lastName",
    required: true,
    value: lastName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["street"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.street"),
    name: "street",
    required: true,
    value: street,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["zipCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.zipcode"),
    name: "zipCode",
    required: true,
    value: zipCode,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["town"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.town"),
    name: "town",
    required: true,
    value: town,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["countryCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.country"),
    name: "countryCode",
    required: true,
    subItems: countries === null || countries === void 0 ? void 0 : countries.map(country => ({
      "attr-value": country.isoCode,
      text: country.title
    })),
    value: countryCode,
    SelectProps: {
      variant: "outlined",
      onChange: e => {
        setCountryCode(e.target.value);
        setStateCode("");
      }
    }
  }), !(0, _isEmpty.default)(states) && /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: l("reactShop.addresses.state"),
    name: "stateCode",
    subItems: states === null || states === void 0 ? void 0 : states.map(state => ({
      "attr-value": state.code,
      text: state.title
    })),
    value: stateCode,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["phone"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.phone"),
    name: "phone",
    required: true,
    value: phone,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["email"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.email"),
    name: "email",
    required: true,
    value: email,
    TextfieldProps: {
      type: "email",
      variant: "outlined"
    }
  }), shopType === _shopTypes.default.MIXED ? /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["type"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.myAccount.customer.labels.requiredField",
      l: l
    }),
    label: l("reactShop.myAccount.customer.labels.type"),
    name: "type",
    required: true,
    subItems: [{
      "attr-value": "private",
      text: l("reactShop.myAccount.customer.labels.private")
    }, {
      "attr-value": "company",
      text: l("reactShop.myAccount.customer.labels.company")
    }],
    value: type,
    SelectProps: {
      variant: "outlined",
      onChange: e => {
        setType(e.target.value);
      }
    }
  }) : /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "type",
    value: shopType === _shopTypes.default.B2B ? "company" : "private"
  }), (shopType === _shopTypes.default.B2B || type === "company" || (0, _checkVatRules.default)(countryCode, type)) && /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["vat"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.vat"),
    name: "vat",
    required: shopType === _shopTypes.default.B2B || type === "company" ? true : false,
    value: vat,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: billingAddress,
    label: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.billingAddress",
      l: l
    }),
    name: "useSeparateBillingAddress",
    setChecked: setBillingAddress,
    value: true
  }), billingAddress && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["billingSalutation"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.salutation"),
    name: "billingSalutation",
    required: true,
    subItems: [{
      "attr-value": l("reactShop.addresses.Mr"),
      text: l("reactShop.addresses.Mr")
    }, {
      "attr-value": l("reactShop.addresses.Mrs"),
      text: l("reactShop.addresses.Mrs")
    }, {
      "attr-value": l("reactShop.addresses.Divers"),
      text: l("reactShop.addresses.Divers")
    }],
    value: billingSalutation,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.addresses.company"),
    name: "billingCompany",
    value: billingCompany,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingFirstName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.firstname"),
    name: "billingFirstName",
    required: true,
    value: billingFirstName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingLastName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.lastname"),
    name: "billingLastName",
    required: true,
    value: billingLastName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingStreet"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.street"),
    name: "billingStreet",
    required: true,
    value: billingStreet,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingZipCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.zipcode"),
    name: "billingZipCode",
    required: true,
    value: billingZipCode,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingTown"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.town"),
    name: "billingTown",
    required: true,
    value: billingTown,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["billingCountryCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.country"),
    name: "billingCountryCode",
    required: true,
    subItems: countries === null || countries === void 0 ? void 0 : countries.map(country => ({
      "attr-value": country.isoCode,
      text: country.title
    })),
    value: billingCountryCode,
    SelectProps: {
      variant: "outlined",
      onChange: e => {
        setBillingCountryCode(e.target.value);
        setBillingStateCode("");
      }
    }
  }), !(0, _isEmpty.default)(billingStates) && /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: l("reactShop.addresses.state"),
    name: "billingStateCode",
    subItems: billingStates === null || billingStates === void 0 ? void 0 : billingStates.map(state => ({
      "attr-value": state.code,
      text: state.title
    })),
    value: billingStateCode,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingPhone"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.phone"),
    name: "billingPhone",
    required: true,
    value: billingPhone,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingEmail"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.email"),
    name: "billingEmail",
    required: true,
    value: billingEmail,
    TextfieldProps: {
      type: "email",
      variant: "outlined"
    }
  })), !(0, _isEmpty.default)(formMessageObj) && formMessageObj.message && /*#__PURE__*/_react.default.createElement(_Message.default, {
    text: formMessageObj.message,
    type: formMessageObj.type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.buttons, "mco-shop-addresses-form__buttons")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: buttonLabel ? buttonLabel : l("reactShop.addresses.buttons.save"),
    locked: formLocked,
    ButtonProps: {
      color: "primary",
      ref: buttonRef,
      variant: "contained"
    },
    type: "submit"
  })));
};
const FormGuest = _ref2 => {
  let {
    buttonLabel,
    buttonRef,
    lang,
    onSubmit
  } = _ref2;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = (0, _FormGuest.default)();
  const handleResponse = response => {
    const {
      httpError,
      errorFields
    } = response;
    if (!(0, _isEmpty.default)(errorFields)) {
      return;
    }
    if (httpError) {
      return;
    }
    if (onSubmit) onSubmit(response);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.list, "mco-shop-addresses-form")
  }, /*#__PURE__*/_react.default.createElement(_reactForm.default, {
    authorization: true,
    action: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CartApi/UpdateGuestAddress.api"),
    method: "POST",
    contentType: "formData",
    onAfterSubmit: handleResponse
  }, /*#__PURE__*/_react.default.createElement(FormContent, {
    buttonLabel: buttonLabel,
    buttonRef: buttonRef,
    lang: lang
  })));
};
var _default = exports.default = FormGuest;